import { render, staticRenderFns } from "./SuratRujukBalik.vue?vue&type=template&id=429883b0&"
import script from "./SuratRujukBalik.vue?vue&type=script&lang=js&"
export * from "./SuratRujukBalik.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports